'use strict';

var _classCallCheck = require("C:\\Users\\gssak\\Desktop\\block-image\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\gssak\\Desktop\\block-image\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\gssak\\Desktop\\block-image\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\gssak\\Desktop\\block-image\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\gssak\\Desktop\\block-image\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var pump = require('pump');

var tar = require('tar-stream');

var ReadableStream = require('readable-stream').Readable;

var ObjectsStreams =
/*#__PURE__*/
function (_ReadableStream) {
  _inherits(ObjectsStreams, _ReadableStream);

  function ObjectsStreams(options) {
    _classCallCheck(this, ObjectsStreams);

    var opts = Object.assign(options || {}, {
      objectMode: true
    });
    return _possibleConstructorReturn(this, _getPrototypeOf(ObjectsStreams).call(this, opts));
  }

  _createClass(ObjectsStreams, [{
    key: "_read",
    value: function _read() {}
  }]);

  return ObjectsStreams;
}(ReadableStream);
/*
  Transform a tar stream into a stream of objects:

  Output format:
  { path: 'string', content: Stream<Readable> }
*/


var TarStreamToObjects = function TarStreamToObjects(inputStream, callback) {
  var outputStream = new ObjectsStreams();
  var extractStream = tar.extract();
  extractStream.on('entry', function (header, stream, next) {
    stream.on('end', next);

    if (header.type !== 'directory') {
      outputStream.push({
        path: header.name,
        content: stream
      });
    } else {
      outputStream.push({
        path: header.name
      });
      stream.resume();
    }
  }).on('finish', function () {
    return outputStream.push(null);
  });
  pump(inputStream, extractStream);
  callback(null, outputStream);
};

module.exports = TarStreamToObjects;